/** In-memory APS document — set once per ACC file after Document.load. */
let apsDocument: Autodesk.Viewing.Document | null = null;

export function setApsDocument(doc: Autodesk.Viewing.Document | null): void {
  apsDocument = doc;
}

export function getApsDocument(): Autodesk.Viewing.Document | null {
  return apsDocument;
}
